import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_list_item_action = _resolveComponent("v-list-item-action")!
  const _component_v_list_item = _resolveComponent("v-list-item")!

  return (_openBlock(), _createBlock(_component_v_list_item, {
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.detail(_ctx.inventory)))
  }, {
    append: _withCtx(() => [
      _createVNode(_component_v_list_item_action, null, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(_component_v_chip, {
              class: "mr-2",
              variant: "outlined",
              size: "x-small"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.inventory.Bediener), 1)
              ], undefined, true),
              _: 1
            }),
            _createVNode(_component_v_chip, {
              color: _ctx.inventory.statusColor,
              variant: "outlined"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.inventory.date), 1)
              ], undefined, true),
              _: 1
            }, 8, ["color"])
          ])
        ], undefined, true),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_list_item_title, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.inventory.Name), 1)
        ], undefined, true),
        _: 1
      }),
      _createVNode(_component_v_list_item_subtitle, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.inventory.BelegNr), 1)
        ], undefined, true),
        _: 1
      })
    ], undefined, true),
    _: 1
  }))
}